document.addEventListener('DOMContentLoaded', function () {
	const tickerWrapper = document.querySelector('.artist-ticker-wrapper');

	if (!tickerWrapper) {
		return;
	}

	const links = Array.from(tickerWrapper.querySelectorAll('a'));

	if (links.length === 0) {
		return;
	}

	// Wait for layout to be complete before measuring
	setTimeout(function () {
		// Group links into rows based on their vertical position
		const rowMap = new Map();

		links.forEach(function (link) {
			const rect = link.getBoundingClientRect();
			const top = Math.round(rect.top * 10) / 10; // Round to 1 decimal for better grouping

			if (!rowMap.has(top)) {
				rowMap.set(top, []);
			}
			rowMap.get(top).push(link);
		});

		// Convert map to array and sort by top position
		const rows = Array.from(rowMap.values()).sort(function (a, b) {
			return a[0].getBoundingClientRect().top - b[0].getBoundingClientRect().top;
		});

		// Create ticker rows with alternating directions
		rows.forEach(function (rowLinks, rowIndex) {
			const isReverse = rowIndex % 2 === 1;
			const rowContainer = document.createElement('div');
			rowContainer.className = 'ticker-row';

			// Duplicate content for seamless loop (need at least 2 sets)
			const contentWrapper = document.createElement('div');
			contentWrapper.className = 'ticker-content';
			contentWrapper.style.animationDirection = isReverse ? 'reverse' : 'normal';

			// Clone links multiple times for seamless infinite scroll
			// We need enough clones to fill the viewport plus some buffer
			for (let i = 0; i < 3; i++) {
				rowLinks.forEach(function (link) {
					const clone = link.cloneNode(true);
					clone.style.pointerEvents = 'auto';
					contentWrapper.appendChild(clone);
				});
			}

			rowContainer.appendChild(contentWrapper);

			// Replace original links with ticker row
			const firstLink = rowLinks[0];
			firstLink.parentNode.insertBefore(rowContainer, firstLink);
			rowLinks.forEach(function (link) {
				link.remove();
			});
		});
	}, 100);
});
